import { POSITION } from '@app/constants/permission'

import type { Role, ObjectValuesType } from '@app/types'

export const mapRoleToPosition = (role?: Role | null): ObjectValuesType<typeof POSITION> | undefined =>
  role ? POSITION[role] : undefined
